const moduleUpload = {
  namespaced: true,
  state: {
    IS_AGREE: false,
    FINSHED_UPLOAD_STAGE: 1,
    /* 作品相关 */
    CONTEST_ID: 0,
  },
  mutations: {
    SET_IS_AGREE: (state, params) => {
      state.IS_AGREE = params
    },
    SET_FINSHED_UPLOAD_STAGE: (state, params) => {
      state.FINSHED_UPLOAD_STAGE = Math.max(state.FINSHED_UPLOAD_STAGE, params)
    },
    SET_CONTEST_ID: (state, params) => {
      state.CONTEST_ID = params
      console.log('params', params)
    },
    RESET_UPLOAD: state => {
      state.IS_AGREE = false
      state.FINSHED_UPLOAD_STAGE = 1
    },
  },
  actions: {},
  getters: {},
}

export default moduleUpload
